import { Helmet } from "react-helmet-async";
import PageShell from "@/components/PageShell";
import ProductCard from "@/shop/ProductCard";
import { useProducts } from "@/shop/ProductsContext";
import { Reveal } from "@/components/Reveal";

const Shop = () => {
  const { products } = useProducts();
  return (
  <PageShell>
    <Helmet>
      <title>Shop | Zentra Protein Bars — Horse gram Microgreens</title>
      <meta
        name="description"
        content="Buy Zentra protein bars online — single bar, box of 4 and box of 8. 10g plant protein, 2g horsegram microgreens, no added sugar. Delivered across India."
      />
    </Helmet>
    <section className="px-5 py-16 lg:px-12" data-testid="shop-page">
      <div className="mx-auto max-w-[1400px]">
        <Reveal className="mb-10">
          <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#7ED321]">Shop Zentra</p>
          <h1 className="font-display text-4xl uppercase leading-[0.95] text-white sm:text-5xl">
            Everyday Protein. <span className="text-outline">Powered by</span> Microgreens.
          </h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-[#A6A66A] sm:text-base">
            Order online — we confirm every order personally on WhatsApp, with UPI or
            cash-on-delivery options.
          </p>
        </Reveal>
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {products.map((p, i) => (
            <Reveal key={p.sku} delay={i * 0.08} className="h-full">
              <ProductCard product={p} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </PageShell>
  );
};

export default Shop;
